import * as getters from "../../baseQuestion/dynamicDDL/store/getters";
import * as mutations from "../../baseQuestion/dynamicDDL/store/mutations";
import * as actions from "../../baseQuestion/dynamicDDL/store/actions";
import { state as text_state } from "../../baseQuestion/text/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_high_school",
			answer_externally_updated: true
		},
		text_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
